module.exports = __webpack_public_path__ + "img/avatar6.4dd0ea08.png";